import React, { useRef, useEffect, useState } from 'react';
import { Icon } from '@app/src/common/Icon';
import { COLORS } from '@app/src/ui';
import { isClientEnv } from '@app/src/utils/validations';
import { useSelector, useDispatch } from 'react-redux';
import { formatPrice } from '@app/src/utils/normalize';
import {
  clearPhotoVignette,
  postPhotoVignette,
  selectExtracharge
} from '@app/src/views/StepTwo/channelPublication';
import {
  Multimedia,
  Uploader,
  TextButton,
  Price,
  IconCloseWrapper,
  Loading,
  ImagePreview,
  ErrorMessage
} from './styled';

interface Props {
  colorTheme?: string;
  channelId: number;
  imageSrc?: string;
  isShowIconClose?: boolean;
  height?: string;
}

const PHOTO_VIGNETTE_ALIAS: string = 'fotovineta';
const isClient: Boolean = isClientEnv();
const MAX_SIZE: number = 4194304;
const PHOTO_VIGNETTE = {
  MIN_WIDTH: 445,
  MIN_HEIGHT: 236
};

export const MultimediaUpload: React.FC<Props> = ({
  colorTheme,
  channelId,
  imageSrc,
  isShowIconClose,
  height
}) => {

  const dispatch = useDispatch();
  const refWrapper = useRef(null);
  const refImage = useRef(null);
  const isFetching = useSelector(state => state.photoVignette.isFetching);
  const [errorMessage, setErrorMessage] = useState('');
  const extracharges = useSelector(state => state.extracharge.data);
  const categoryId = useSelector(state => state.print.general.category);
  const [indexPhotoVignette, setIndexPhotoVignette] = useState(null);
  const [pricePhotoVignette, setPricePhotoVignette] = useState(null);
  const [isShowImage, setIsShowImage] = useState(false);

  useEffect(() => {
    if (extracharges && extracharges[channelId] && extracharges[channelId].data ) {
      const position = extracharges[channelId].data.map((item) => { return item.alias; }).indexOf(PHOTO_VIGNETTE_ALIAS);
      const price = formatPrice(extracharges[channelId].data[position].price);
      setIndexPhotoVignette(position);
      setPricePhotoVignette(price)
    }
  }, [extracharges]);

  useEffect(() => {
    if (imageSrc) {
      setIsShowImage(true);
      if (indexPhotoVignette >= 0) {
        dispatch(selectExtracharge(channelId, indexPhotoVignette, true));
      }
    }
  }, [imageSrc]);

  const handleClickClearImage = () => {
    dispatch(clearPhotoVignette(channelId));
    setIsShowImage(false);
    if (indexPhotoVignette >= 0) {
      dispatch(selectExtracharge(channelId, indexPhotoVignette, false));
    }
  };

  const getValidDimensionImage = async(currentFile) => {
    setErrorMessage('')
    if (!(currentFile.type === 'image/jpeg' || currentFile.type === 'image/png' )) {
      setErrorMessage('Formato permitido: jpeg, png');
      return true;
    }
    if (currentFile.size > MAX_SIZE) {
      setErrorMessage('La imagen supera los 4MB');
      return true;
    }
    const img = await buildImage(currentFile);
    if (img['width'] < PHOTO_VIGNETTE.MIN_WIDTH || img['height'] < PHOTO_VIGNETTE.MIN_HEIGHT) {
      setErrorMessage(`Tamaño mínimo de imagen: ${PHOTO_VIGNETTE.MIN_WIDTH}x${PHOTO_VIGNETTE.MIN_HEIGHT}`);
      return true;
    }
    return false;
  };

  const buildImage = (currentFile) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const objectUrl = window.URL.createObjectURL(currentFile);
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = objectUrl;
    })
  };

  const handleChange = async (e) => {
    if (isClient) {
      const file = e.target.files[0];
      const isErrorImage = await getValidDimensionImage(file);
      if (!isErrorImage) {
        dispatch(postPhotoVignette(categoryId, channelId, file));
      }
    }
  };

  const getIsDisplayImage = () => isShowImage && !errorMessage && !isFetching;

  return(
  <Multimedia ref={refWrapper} isDisplayImage={getIsDisplayImage()} height={height}>
    <ImagePreview
      isDisplay={getIsDisplayImage()}
      ref={refImage}
      src={imageSrc}
    />
    {
      (isFetching) ?
        <Loading><Icon data-name='icon-circle' fill='#ccc' width={'17'} height={'17'} /></Loading>
      :
        (isShowImage && !errorMessage) ?
          isShowIconClose && <IconCloseWrapper color={colorTheme} onClick={handleClickClearImage}>
            <Icon data-name="icon-close-bold" width="14" height="14" fill="#fff" />
          </IconCloseWrapper>
        :
          <React.Fragment>
            <Icon data-name="icon-camera" width="36" height="36" fill={COLORS.GRAY_PLACEHOLDER} />
            <Uploader color={colorTheme}>
              <input
                type="file"
                accept="image/*"
                autoComplete="off"
                onChange={handleChange}
              />
              <TextButton>Agregar foto<Price>S/ {pricePhotoVignette}</Price></TextButton>
            </Uploader>
          </React.Fragment>
    }
    { errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    { !isShowImage && !isFetching && !errorMessage && <span>Peso máximo permitido: 4MB</span>}
  </Multimedia>
)};
